import { Button, Chip, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import ToolTip from "../../../ToolTip/ToolTip";
import { render } from "@testing-library/react";

export const Student_Attendace_Head = (
  navigate,
  month,
  year,
  courseEnrollmentId
) => [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "attendance_date",
    headerName: "Date",
    width: 150,
  },
  {
    field: "from_time",
    headerName: "From Time",
    width: 150,
  },
  {
    field: "to_time",
    headerName: "To Time",
    width: 150,
  },
  {
    field: "attendance_type_name",
    headerName: "Attendance Type",
    width: 150,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.attendance_type_name}
          expand={params.row.attendance_type_name}
        />
      );
    },
  },
  {
    field: "subject_name",
    headerName: "Subject",
    width: 200,
  },
  {
    field: "lessons",
    headerName: "Lessons",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip content={params.row.lessons} expand={params.row.lessons} />
      );
    },
  },
  {
    field: "trainer_remarks",
    headerName: "Remarks",
    width: 150,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.trainer_remarks}
          expand={params.row.trainer_remarks}
        />
      );
    },
  },
  {
    field: "trainer_name",
    headerName: "Trainer Name",
    width: 200,
  },
  {
    field: "attendance_timestamp",
    headerName: "Time Stamp",
    width: 200,
  },
  {
    field: "action",
    headerName: "Action",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          variant="contained"
          size="small"
          color="error"
          onClick={() => {
            const url = `https://workspace.teaminterval.net/employee/student_attendance_view/${courseEnrollmentId}/${year}/${month}`;
            window.open(url, "_blank");
          }}
        >
          <Icon
            icon="material-symbols-light:delete-rounded"
            width={20}
            height={20}
          />
          Delete
        </Button>
      );
    },
  },
];
